export interface IRewardCoinsUtil {
	segmentName: string;
	bonusUtil: number;
	cashbackUtil: number;
}
export interface IRewardCoinsUtilPriorityPayload {
	coinType: ESupportedRewardCoinsUtil;
	priorityList: string[];
}
export enum ESupportedRewardCoinsUtil {
	cashbackCoins = 'cashbackCoins',
	bonusCoins = 'bonusCoins'
}
export interface IDeleteRewardCoinsUtilPayload {
	segmentName: string;
}
export interface IRewardCoinsUtilResponse {
	dashboardListData: IRewardCoinsUtil[];
	bonusSegmentPriorityList: string[];
	cashbackSegmentPriorityList: string[];
	success: boolean;
}

export interface RESPONSE {
	success: boolean;
	externalMessage?: string;
	message?: string;
}
